import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';
import { JobOffering, JobPeriod } from 'types/AppTypes';

export const jobOfferDeactivationModalValidationSchema = (
  t: TFunction<'translation', undefined>
) => ({
  jobPeriodIds: yup
    .array()
    .of(yup.number())
    .min(1, t(translations.validation.minOne()))
    .label(t(translations.pages.deactivateJobOffers.steps.jobPeriods()))
});

export const jobOfferDeactivationModalInitialValues = (
  value: (JobOffering & { jobPeriods: JobPeriod[] }) | null
) => {
  return { jobOffering: value, jobPeriodIds: [] };
};
